// Progression: skills rise only by doing them. Jobs (Final Fantasy style) will level the same way, each on its own.
export interface SkillDef { id: string; name: string; kind: 'gathering' | 'crafting' | 'combat' | 'job' }

export const SKILLS: SkillDef[] = [
  { id: 'foraging', name: 'Foraging', kind: 'gathering' },
  { id: 'fishing', name: 'Fishing', kind: 'gathering' },
  { id: 'woodcutting', name: 'Woodcutting', kind: 'gathering' },
  { id: 'mining', name: 'Mining', kind: 'gathering' },
  { id: 'cooking', name: 'Cooking', kind: 'crafting' },
  { id: 'crafting', name: 'Crafting', kind: 'crafting' },
  { id: 'building', name: 'Building', kind: 'crafting' },
  { id: 'adventuring', name: 'Adventuring', kind: 'combat' },
  // job levels (shared/jobs.ts): shown in the Jobs tab, not the Skills list
  { id: 'job_knight', name: 'Knight', kind: 'job' },
  { id: 'job_wizard', name: 'Wizard', kind: 'job' },
  { id: 'job_cleric', name: 'Cleric', kind: 'job' },
  { id: 'job_rogue', name: 'Rogue', kind: 'job' },
];
export const skillDef = (id: string) => SKILLS.find(s => s.id === id);

export const MAX_LEVEL = 100;
/** Total xp needed to reach a level: gentle at first, steeper later. Level 1 = 0 xp. */
export function xpForLevel(level: number): number {
  const l = Math.max(1, Math.min(MAX_LEVEL, level)) - 1;
  return Math.round(40 * l + 6 * l * l + 0.08 * l ** 3.2);
}
export function levelForXp(xp: number): number {
  let lv = 1; while (lv < MAX_LEVEL && xp >= xpForLevel(lv + 1)) lv++;
  return lv;
}

/** Item binding: who may hold an item once it exists. Enforced on the server for trade, mail and the market. */
export type Bind = 'none' | 'pickup' | 'equip' | 'account';
